import { useParams } from "react-router-dom";
import { useGetCourseUnits } from "./useGetCourseUnits";

export function useNextUnit() {
	const { courseSlug, moduleSlug, unitSlug } = useParams();
	const { course, modules, isPending, isSuccess, isError, error } =
		useGetCourseUnits({ courseSlug });

	const calculateNextUnitAndModule = function () {
		if (!course || !modules)
			return { nextUnit: null, nextUnitModule: null };

		let module_idx = -1;
		let unit_idx = -1;
		for (let i = 0; i < modules.length; i++) {
			if (modules[i].slug == moduleSlug) {
				module_idx = i;
				break;
			}
		}

		if (module_idx == -1) null;

		for (let i = 0; i < modules[module_idx].units.length; i++) {
			if (modules[module_idx].units[i].slug == unitSlug) {
				unit_idx = i;
				break;
			}
		}

		if (unit_idx == -1) return null;

		// return the next unit in the current module
		if (unit_idx + 1 < modules[module_idx].units.length)
			return {
				nextUnit: modules[module_idx].units[unit_idx + 1],
				nextUnitModule: modules[module_idx],
			};

		// the first unit in the next module
		for (let i = module_idx + 1; i < modules.length; i++)
			if (modules[i].units.length > 0)
				return {
					nextUnit: modules[i].units[0],
					nextUnitModule: modules[i],
				};

		return null;
	};

	return {
		isPending,
		isSuccess,
		isError,
		error,
		...calculateNextUnitAndModule(),
	};
}
